import React, {useState} from 'react'

export default (WrappedComponent) => (props) => {
  const [open, setOpen] = useState(true)

  const handleToggle = () => setOpen((open) => !open)

  return <WrappedComponent {...props} open={open} onToggle={handleToggle} />
}
